import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=5054087c&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=5054087c&prod&lang=scss&scoped=true"
import style1 from "./Products.vue?vue&type=style&index=1&id=5054087c&prod&lang=scss&scoped=true"
import style2 from "./Products.vue?vue&type=style&index=2&id=5054087c&prod&scoped=true&lang=css"
import style3 from "./Products.vue?vue&type=style&index=3&id=5054087c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054087c",
  null
  
)

export default component.exports